import * as React from "react";
import { Helmet } from "react-helmet";
import HeroTextOnLeftBlock from "../layouts/hero-text-on-left-block/hero-text-on-left-block";
import TitleBlock from "../layouts/title-block/title-block";
import PricingTableBlock from "../layouts/pricing-table-block/pricing-table-block";
import IntroStepSelectBlock from "../layouts/intro-step-select-block/intro-step-select-block";
import FeaturesVerticalBlock from "../layouts/features-vertical-block/features-vertical-block";
import ContactFormBlock from "../layouts/contact-form-block/contact-form-block";
import { PageType } from "../models/types";
import {GoogleAnalyticsEventType} from "../models/google-analytics";
import * as staticImages from "../constants/static-images";
import * as featuresVerticalData from "../constants/features-vertical-data";
import * as initialFormData from "../constants/form-data";
import * as freshworksData from "../constants/freshworks-data";
import * as helmetData from "../constants/helmet-data";
import * as cacheBustingService from "../services/cache-busting-service";

interface BiuroRachunkowePageProps {}

interface BiuroRachunkowePageState {}

class BiuroRachunkowePage extends React.Component<BiuroRachunkowePageProps,BiuroRachunkowePageState> {

  componentDidMount() {
    cacheBustingService.handleCacheBusting(caches);
  }

  render() {
    return (
      <div>
        <Helmet {...helmetData.prepareHelmetData(PageType.BiuroRachunkowePage)}/>

        <HeroTextOnLeftBlock
          title={"Biuro Rachunkowe Online"}
          description={["Nie masz czasu na samodzielną księgowość?","Skorzystaj z pomocy profesjonalistów."]}
          backgroundImage={staticImages.BIURO_RACHUNKOWE_BACKGROUND_IMAGE}
          componentViewEventType={GoogleAnalyticsEventType.BiuroRachunkowePageViewedMainTitleBlock}
        />

        <TitleBlock
          firstLineBlackStart={"Szukasz rzetelnej"}
          firstLineBlue={"księgowości"}
          firstLineBlackEnd={"?"}
          secondLineText={"Dobrze trafiłeś."}
          paddingTop={70}
          paddingBottom={0}
        />
        <IntroStepSelectBlock
          stepSelectElements={[
            {
              elementSelectorTitle: "PROFESJONALIZM",
              elementSelectorDescription: "Nasz zespół to osoby z odpowiednim wykształceniem kierunkowym, które mogą się pochwalić certyfikatami świadczącymi o posiadanych kwalifikacjach oraz doświadczeniem w najbardziej renomowanych firmach audytorsko-podatkowych na świecie."
            },
            {
              elementSelectorTitle: "ELASTYCZNOŚĆ",
              elementSelectorDescription: "Na bieżąco monitorujemy potrzeby oraz oczekiwania Naszych Klientów. Zawsze szukamy rozwiązań optymalnych dla danego podmiotu. Do każdego klienta podchodzimy w sposób indywidualny."
            },
            {
              elementSelectorTitle: "BEZPIECZEŃSTWO",
              elementSelectorDescription: "Bezpieczeństwo finansowe Naszych Klientów jest dla nas najważniejsze i jako podmiot profesjonalny gwarantujemy poufność i bezpieczeństwo informacji."
            }
          ]}
          componentViewEventType={GoogleAnalyticsEventType.BiuroRachunkowePageViewedStepSelectBlock}
          elementSelectEventType={GoogleAnalyticsEventType.BiuroRachunkowePageClickedStepSelectElement}
        />

        <TitleBlock
          firstLineBlackStart={"Przejrzyste zasady"}
          firstLineBlue={"współpracy"}
          firstLineBlackEnd={""}
          secondLineText={"Cennik usługowego prowadzenia ksiąg handlowych (pełna księgowość). Wszystkie podane ceny są cenami netto."}
          paddingTop={20}
        />
        <PricingTableBlock
          packagesInfo={
            {
              packageFeaturesTitle: "DOSTĘPNE PAKIETY",
              packageFeaturesSubtitle: "Informacje",
              packageFeatureColumnSize: 3,
              packageFeatures: [
                {
                  featureName: "Liczba dokumentów",
                  featureHasTooltip: true,
                  featureDescription: "Łączna liczba dokumentów sprzedażowych (nie dotyczy FIRMA 3) i kosztowych."
                },
                {
                  featureName: "Dodatkowy dokument",
                  featureHasTooltip: true,
                  featureDescription: "Opłata za każdy nadliczbowy dokument sprzedażowy lub kosztowy (nie dotyczy transakcji międzynarodowych)."
                },
                {
                  featureName: "Transakcje międzynarodowe",
                  featureHasTooltip: true,
                  featureDescription: "Liczba międzynarodowych faktur sprzedażowych i kosztowych zawartych w pakiecie."
                },
                {
                  featureName: "Liczba pracowników",
                  featureHasTooltip: true,
                  featureDescription: "Łączna liczba pracowników zatrudnionych w firmie na podstawie umowy cywilnoprawnej lub aktu powołania."
                },
                {
                  featureName: "Dodatkowy pracownik",
                  featureHasTooltip: true,
                  featureDescription: "Opłata za prowadzenie rozliczeń dodatkowego pracownika w firmie."
                },
                {
                  featureName: "Reprezentacja przed US",
                  featureHasTooltip: true,
                  featureDescription: "Reprezentacja podatnika przed urzędami skarbowymi."
                },
                {
                  featureName: "e-Deklaracje",
                  featureHasTooltip: true,
                  featureDescription: "Generowanie i wysyłanie plików e-Deklaracji."
                },
                {
                  featureName: "JPK",
                  featureHasTooltip: true,
                  featureDescription: "Generowanie i wysyłanie plików JPK."
                },
                {
                  featureName: "Indywidualny księgowy",
                  featureHasTooltip: true,
                  featureDescription: "Do obsługi Twojej firmy przydzielony będzie indywidualny księgowy, który zadba o Twoje sprawy podatkowo-księgowe."
                },
              ]
            }
          }
          packages={[
            {
              packageFeatureColumnSize: 3,
              packageName: "FIRMA 3 / PODMIOT NIEAKTYWNY",
              packagePrice: 500,
              packagePricingInfo: "ZŁ / MC",
              packagePricingNetInfoVisible: true,
              packageIsFeatured: false,
              packageIsCurrent: false,
              packageFeatures: [
                {
                  featureType: "text",
                  featureText: "do 3",
                  featureIncluded: true
                },
                {
                  featureType: "text",
                  featureText: "niedostępne",
                },
                {
                  featureType: "text",
                  featureText: "niedostępne",
                },
                {
                  featureType: "text",
                  featureText: "niedostępne",
                },
                {
                  featureType: "text",
                  featureText: "niedostępne",
                },
                {
                  featureType: "icon",
                  featureIncluded: true
                },
                {
                  featureType: "icon",
                  featureIncluded: true
                },
                {
                  featureType: "icon",
                  featureIncluded: true
                },
                {
                  featureType: "icon",
                  featureIncluded: true
                },
              ],
              packageButtonHidden: false,
              packageButtonText: "Wybieram",
              packageButtonLinkTo: "#biuro-rachunkowe",
              packageButtonLinkIsForScrolling: true
            },
            {
              packageFeatureColumnSize: 3,
              packageName: "FIRMA 15",
              packagePrice: 700,
              packagePricingInfo: "ZŁ / MC",
              packagePricingNetInfoVisible: true,
              packageIsFeatured: true,
              packageIsCurrent: true,
              packageFeatures: [
                {
                  featureType: "text",
                  featureText: "do 15",
                },
                {
                  featureType: "text",
                  featureText: "10 zł / szt",
                },
                {
                  featureType: "text",
                  featureText: "1",
                },
                {
                  featureType: "text",
                  featureText: "1",
                },
                {
                  featureType: "text",
                  featureText: "50 zł / osoba",
                },
                {
                  featureType: "icon",
                  featureIncluded: true
                },
                {
                  featureType: "icon",
                  featureIncluded: true
                },
                {
                  featureType: "icon",
                  featureIncluded: true
                },
                {
                  featureType: "icon",
                  featureIncluded: true
                }
              ],
              packageButtonHidden: false,
              packageButtonText: "Wybieram",
              packageButtonLinkTo: "#biuro-rachunkowe",
              packageButtonLinkIsForScrolling: true
            },
            {
              packageFeatureColumnSize: 3,
              packageName: "FIRMA 30",
              packagePrice: 850,
              packagePricingInfo: "ZŁ / MC",
              packagePricingNetInfoVisible: true,
              packageIsFeatured: false,
              packageIsCurrent: false,
              packageFeatures: [
                {
                  featureType: "text",
                  featureText: "do 30",
                },
                {
                  featureType: "text",
                  featureText: "8 zł / szt",
                },
                {
                  featureType: "text",
                  featureText: "2",
                },
                {
                  featureType: "text",
                  featureText: "2",
                },
                {
                  featureType: "text",
                  featureText: "40 zł / osoba",
                },
                {
                  featureType: "icon",
                  featureIncluded: true
                },
                {
                  featureType: "icon",
                  featureIncluded: true
                },
                {
                  featureType: "icon",
                  featureIncluded: true
                },
                {
                  featureType: "icon",
                  featureIncluded: true
                }
              ],
              packageButtonHidden: false,
              packageButtonText: "Wybieram",
              packageButtonLinkTo: "#biuro-rachunkowe",
              packageButtonLinkIsForScrolling: true
            },
          ]}
          componentViewEventType={GoogleAnalyticsEventType.BiuroRachunkowePageViewedPricingTableBlock}
          buttonClickEventType={GoogleAnalyticsEventType.BiuroRachunkowePageClickedCTAButtonAtPricingTableBlock}
        />

        <TitleBlock
          firstLineBlackStart={""}
          firstLineBlue={"Profesjonalne"}
          firstLineBlackEnd={"usługi księgowe"}
          secondLineText={"Poznaj zalety nowoczesnego biura rachunkowego."}
          paddingTop={90}
          paddingBottom={40}
        />
        <FeaturesVerticalBlock
          features={featuresVerticalData.BIURO_RACHUNKOWE_VERTICAL_FEATURES}
          componentViewEventType={GoogleAnalyticsEventType.BiuroRachunkowePageViewedFeaturesVerticalBlock}
          buttonClickEventType={GoogleAnalyticsEventType.BiuroRachunkowePageClickedFeaturesVerticalElement}
        />

        <TitleBlock
          id={"biuro-rachunkowe"}
          firstLineBlackStart={"Poznaj szczegóły"}
          firstLineBlue={"współpracy"}
          firstLineBlackEnd={""}
          secondLineText={"Jeśli interesują Cię szczegóły, zapraszamy do nawiązania kontaktu."}
          paddingTop={75}
          paddingBottom={0}
        />
        <ContactFormBlock
          formInfo={initialFormData.BiuroRachunkowePageFormInfo}
          iframeSourceUrl={freshworksData.BIURO_RACHUNKOWE_PAGE_FORM_IFRAME_SOURCE_URL}
        />

        <div style={{marginTop:220}}/>

      </div>
    )
  }

}

export default BiuroRachunkowePage


// WEBPACK FOOTER //
// ./src/pages/biuro-rachunkowe.tsx